
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productWrapper = this.closest('.product-item-js')
    this.addEventListener('change', this.onVariantChange);
    if (!this.querySelector('.variant-radios')) return;
    this.variantRadios = this.querySelectorAll('.variant-radios');
    this.variantRadiosInputs = this.querySelectorAll('.variant-radios input');
    // this.variantRadiosInputs.forEach(input => input.addEventListener('change', this.onVariantChange.bind(this) ));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.renderProductInfo();
    this.updateOptionsLabels();
    // this.removeErrorMessage();

    if (!this.currentVariant) {
      this.updateAvailability(false);
    } else {
      this.updateAvailability(this.currentVariant.available);
      this.updateMedia();
      const varient_id =  this.currentVariant.id;
      const product_id =  this.currentVariant.featured_image.product_id;
      console.log(varient_id +'-'+product_id);
      document.getElementById('product-select-'+product_id).value = varient_id;
      // this.updateURL();
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.variant-selector select'), (select) => select.value);
    if (!this.variantRadios.length > 0) return;
    const swatches = Array.from(this.variantRadios);
 
    this.options = this.options.concat(
      swatches.map((swatch) => {
        return Array.from(swatch.querySelectorAll('input')).find((radio) => radio.checked).value;
      })
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const originalImageElement = this.productWrapper.querySelector('.aspect-ratio img');
    let featured_media_Src = this.currentVariant.featured_media.preview_image.src;
    featured_media_Src = featured_media_Src.substring(0, featured_media_Src.lastIndexOf('.')) + '`' + featured_media_Src.substring(featured_media_Src.lastIndexOf('.') + 1);
    featured_media_Src = featured_media_Src.replace('`', '_{width}x.');
    // console.log(featured_media_Src);
    var newImageElement = document.createElement('img');
    newImageElement.className = 'lazyload image--fade-in';
    newImageElement.setAttribute('data-src', featured_media_Src);
    newImageElement.setAttribute('data-widths', originalImageElement.getAttribute('data-widths'));
    newImageElement.setAttribute('data-sizes', 'auto');

    originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);

  }

  updateVariantInput() {
    const input = this.productWrapper.querySelector('input[name="quantity"]');
    input.dataset.variantId = this.currentVariant.id;
    this.productWrapper.querySelector('[name="quantity"]').dataset.price = this.currentVariant.price;

    this.productWrapper.querySelector('[name="quantity"]').dataset.variantTitle = this.currentVariant.title;

    input.setAttribute('max', window.builderVariantsStocks[this.currentVariant.id.toString()]);
    if (parseInt(input.value) > parseInt(input.max)) input.value = input.max;
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=price&section_id=builder-item-price`)
      .then((response) => response.text())
      .then((responseText) => {

        let html = new DOMParser().parseFromString(responseText, 'text/html')
        let destination = this.productWrapper.querySelector('.product-item__price-list');
        let source = html.querySelector('.product-item__price-list');

        if (source && destination) destination.innerHTML = source.innerHTML;
       // document.addEventListener('collection:updated', cabinetCollectionGeneralColorSwatch);
      });
  }

  updateOptionsLabels() {
    this.querySelectorAll('.product-form__selected-value').forEach((label, index) => {
      const option = "option".concat(++index);
      label.innerHTML = this.currentVariant[option];
    })
  }

  updateAvailability(available) {
    if (available) {
      this.productWrapper.querySelector('.quantity-selector').classList.remove('tw-hidden');
      this.productWrapper.querySelector('.sold-out-label-js').classList.add('tw-hidden');
    } else {
      this.productWrapper.querySelector('.quantity-selector').classList.add('tw-hidden');
      this.productWrapper.querySelector('.sold-out-label-js').classList.remove('tw-hidden');
    }
  }

  getVariantData() {
    if (this.querySelector('[type="application/json"]')) {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    } else {
      this.variantData = this.variantData || JSON.parse(this.parentElement.querySelector('variant-selects').querySelector('[type="application/json"]').textContent);
    }
    return this.variantData;
  }
}
// window.renderProductInfo()
customElements.define('variant-selects', VariantSelects);
